<template>
  <div class="Register">
    <div class="sr">
      <div class="sr_title">我的用户信息</div>
      <div class="sr_body">
        <div class="company">
          <div class="cp_title">
            <span>公司信息</span>
          </div>
          <div class="cp_items flex_row">
            <div class="cp_item flex_row">
              <div class="item_info">公司名称：</div>
              <div class="item_input flex_row">
                <input type="text" v-model="ApplyName" required="required" placeholder="请输入公司名称" />
              </div>
            </div>
            <div class="cp_item flex_row">
              <div class="item_info">手机号码：</div>
              <div class="item_input flex_row">
                <input class="text" type="tel" v-model="ApplyTel" maxlength="11" placeholder="请输入手机号码"
                  @blur="checkPhone(ApplyTel, 1)" />
              </div>
            </div>
            <div class="cp_item flex_row">
              <div class="item_info">联系人：</div>
              <div class="item_input flex_row">
                <input class="text" type="text" size="small" v-model="ApplyPerson" placeholder="请输入联系人" />
              </div>
            </div>
          </div>
          <div class="cp_items flex_row">
            <div class="cp_item flex_row" style="position: relative">
              <div class="item_info">省市地区：</div>
              <div class="item_input flex_row">
                <AreaCascader v-model="areaInfo" />
              </div>
            </div>
            <div class="cp_item flex_row">
              <div class="item_info">详细地址：</div>
              <div class="item_input flex_row">
                <input class="text" type="text" v-model="ApplyAddress" placeholder="请输入地址" />
              </div>
            </div>
            <div class="cp_item flex_row"></div>
          </div>
          <div class="cp_items flex_row">
            <div class="cp_item flex_row">
              <div class="item_info">营业执照：</div>
              <div class="upfile_content flex_row" style="flex: 1">
                <div class="fileBox flex_row">
                  <span class="fileinput-button flex_row" style="
                      width: 0.5rem;
                      height: 0.5rem;
                      background-size: 0.5rem auto;
                    ">
                    <el-image v-show="isBusiness" style="width: 0.5rem; height: 0.5rem" :src="srcBusiness" fit="cover">
                    </el-image>
                    <input type="file" style="width: 0.5rem; height: 0.5rem"
                      @change="getFileProcess($event, 'business')" />
                  </span>
                </div>
                <div class="fileBox-word" style="
                    height: 0.1rem;
                    line-height: 0.1rem;
                    color: #b6b6b6;
                    font-size: 0.12rem;
                  ">
                  （点击上传）
                </div>
              </div>
            </div>
            <div class="cp_item flex_row">
              <div class="item_info">公司Logo：</div>
              <div class="upfile_content flex_row">
                <div class="fileBox flex_row">
                  <span class="fileinput-button flex_row" style="
                      width: 0.5rem;
                      height: 0.5rem;
                      background-size: 0.5rem auto;
                    ">
                    <el-image v-show="isLogo" style="width: 0.5rem; height: 0.5rem" :src="srcLogo" fit="cover">
                    </el-image>
                    <input type="file" style="width: 0.5rem; height: 0.5rem" @change="getFileProcess($event, 'logo')" />
                  </span>
                </div>
                <div class="fileBox-word" style="
                    height: 0.1rem;
                    line-height: 0.1rem;
                    color: #b6b6b6;
                    font-size: 0.12rem;
                  ">
                  （点击上传）
                </div>
              </div>
              <div class="cursor-pointer item_info" style="flex: 1; color: #f60f60; font-size: 12px"
                @click="modelShowDialog = true">
                查看模板
              </div>
              <!--              <div style="height: 0.5rem; flex: 1; display: flex; justify-content: flex-start" ><img style="height: 0.5rem" src="@/assets/img/logo_model.png" alt=""></div>-->
            </div>
            <div class="cp_item flex_row">
              <div class="item_info1">申请人单位代表签名：</div>
              <div class="item_input flex_row" @click="dialogVisibleSign = true" style="flex: 1; margin-left: 0.3rem">
                <img v-show="!srcSign" style="width: 0.5rem" src="@/assets/img/gw_add.png" alt="" />
                <img v-show="srcSign" style="height: 0.5rem" :src="srcSign" alt="" />
              </div>
            </div>
          </div>
          <div class="cp_items flex_row">
            <div class="cp_item flex_row">
              <div class="item_info">渠道编码：</div>
              <div class="item_input flex_row">
                <!-- <el-select
                  size="small"
                  v-model="ApplySource"
                  @change="changeApplySource"
                  placeholder="请选择渠道"
                >
                  <el-option
                    v-for="item in ApplySourceList"
                    :key="item.Type"
                    :label="item.Label"
                    :value="item.Label"
                  >
                  </el-option>
                </el-select> -->
                <el-input style="width: 200px" size="small" v-model="ApplySource" placeholder="请输入渠道编码"
                  @change="changeApplySource"></el-input>
              </div>
            </div>
            <div class="cp_item flex_row">
              <div class="item_info">申请版本：</div>
              <div class="item_input flex_row" style="flex: 1">
                <el-select size="small" v-model="ApplyVersion" :disabled="!ApplySource" placeholder="请选择版本">
                  <el-option v-for="item in ApplyVersionList" :key="item.keys" :label="item.value" :value="item.keys">
                  </el-option>
                </el-select>
                <el-button style="margin-left: 10px" type="primary" size="small" @click="goVersion">版本区别</el-button>
              </div>
            </div>

            <div class="cp_item flex_row">
              <!-- <div class="item_info">申请期限：</div>
              <div class="item_input flex_row" style="flex: 1">
                <el-select v-model="ApplyTerm" placeholder="请选择期限">
                  <el-option
                    v-for="item in ApplyTermList"
                    :key="item.keys"
                    :label="item.Label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div> -->
            </div>
          </div>
        </div>
        <div class="store">
          <div class="store_top flex_row">
            <div class="se_title">
              <span>门店信息</span>
            </div>
            <div class="informDiv" style="margin-right: 1%">
              <el-button type="primary" size="mini" @click="add" style="margin-right: 10px">新增门店信息</el-button>
              <!--              <el-button type="primary" size="mini" style="margin-right: 10px">去支付</el-button>-->
              <el-checkbox v-model="Agree">
                <span style="color: #171717">同意签署<a style="color: #409eff; text-decoration: underline"
                    @click="agreenClick">《授权使用同意书》</a>并遵守全部条款
                </span>
                <!--                <a style="color: #409EFF; text-decoration: underline" @click="agreenClick">授权使用同意书</a>-->
              </el-checkbox>
            </div>
          </div>
          <div class="store_content">
            <div class="content_top flex_row">
              <div style="flex: 0.6"></div>
              <div>门店名称</div>
              <div>手机</div>
              <div>联系人</div>
              <div>地区（省/市）</div>
              <div>详细地址</div>
              <div>专家号码</div>
              <div>门头照片</div>
              <div style="flex: 1">删除</div>
            </div>
            <div class="content_body">
              <div class="store_items flex_row" :style="{ background: index % 2 == 0 ? '#FFF' : '#EEE' }"
                v-for="(item, index) in ListShop" :key="index + 'Shop'">
                <!-- 同步信息 -->
                <button @click="handleSyncShopInfo(index)" class="px-4 py-2 text-white bg-blue-500">同步信息</button>
                <div class="store_item flex_row">
                  <input type="text" v-model="item.ApplyName" placeholder="请输入店面名称" />
                </div>
                <div class="store_item flex_row">
                  <input type="tel" v-model="item.ApplyTel" maxlength="11" placeholder="请输入店面手机号码"
                    @blur="checkPhone(item.ApplyTel, 2, index)" />
                </div>
                <div class="store_item flex_row">
                  <input type="text" v-model="item.ApplyPerson" placeholder="请输入店联系人" />
                </div>
                <div class="store_item flex_row">
                  <!-- <input
                    type="text"
                    v-model="item.ApplyRegion"
                    readonly="readonly"
                    placeholder="请输入店面省/市"
                    @click="showDivWrap(index)"
                  /> -->
                  <AreaCascader v-model="item.areaInfo" />
                </div>
                <div class="store_item flex_row">
                  <input type="text" v-model="item.ApplyAddress" placeholder="请输入店面地址" />
                </div>
                <div class="store_item flex_row">
                  <input type="tel" v-model="item.ApplyExpertTel" maxlength="11" placeholder="请输入专家手机号码"
                    @blur="checkPhone(item.ApplyExpertTel, 3, index)" />
                </div>
                <div class="store_item flex_row">
                  <div class="upfile_content flex_row">
                    <div class="fileBox flex_row">
                      <span class="fileinput-button flex_row" style="
                          width: 0.4rem;
                          height: 0.4rem;
                          background-size: 0.4rem auto;
                        ">
                        <el-image v-show="item.isStore" style="width: 0.4rem; height: 0.4rem" :src="item.srcStore"
                          fit="cover">
                        </el-image>
                        <input type="file" style="width: 0.4rem; height: 0.4rem"
                          @change="getFileProcess($event, '', index)" />
                      </span>
                    </div>
                    <div class="fileBox-word" style="
                        height: 0.065rem;
                        line-height: 0.065rem;
                        color: #b6b6b6;
                        font-size: 0.11rem;
                      ">
                      （点击上传）
                    </div>
                  </div>
                </div>
                <div class="store_item flex_row" style="flex: 1">
                  <button class="delect flex_row" @click="delectClick" :data-index="index">
                    <img src="@/assets/img/delect.png" :data-index="index" alt="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_row">
          <el-button class="submit1" type="primary" size="small" @click="submit">提交</el-button>
          <el-button class="submit1" type="primary" size="small" @click="cancel">返回</el-button>
          <!--          <el-button class="submit" @click="submit">提交</el-button>-->
          <!--          <el-button class="submit" @click="cancel">返回</el-button>-->
        </div>
      </div>
    </div>
    <img class="back" src="@/assets/img/informate.jpg" alt="" />
    <el-dialog title="版本区别" width="90%" :visible.sync="dialogVisible">
      <div class="VersionDifferent">
        <div class="version_tips">
          以下功能分别分布在：患者手机端，诊疗流程PAD/PC端，医生手机端，管理PC端
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="@/assets/img/version_star.png" style="width: 0.18rem; height: 0.18rem"
            alt="" />&nbsp;&nbsp;说明需要设备支持
        </div>
        <div class="version_top_back flex_column">
          <div class="version_top version_top1 flex_row">
            <div class="top_item flex_column item_blue">
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row">机构属性</div>
              </div>
            </div>
            <div style="flex: 1" class="top_item flex_column item_yellow">
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row">眼健康公益</div>
              </div>
            </div>
            <div class="top_item flex_column item_pink">
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row">非医疗机构</div>
              </div>
            </div>
            <div class="top_item flex_column item_green">
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row top_item_inner_right">
                  医疗机构
                </div>
              </div>
            </div>
          </div>

          <div class="version_top version_top2 flex_row">
            <div class="top_item flex_column item_blue">
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row">模块</div>
              </div>
            </div>
            <div class="top_item flex_column item_blue">
              <div class="top_item_top flex_row flex_3">
                <div class="top_item_inner flex_row">功能清单</div>
              </div>
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row">初装费</div>
              </div>
            </div>
            <div class="top_item flex_column item_yellow">
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row">公益版</div>
              </div>
              <div class="top_item_top flex_row flex_2">
                <div class="top_item_inner flex_row">健康科普/管理</div>
              </div>
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row">NA</div>
              </div>
            </div>
            <div class="top_item flex_column item_pink">
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row">眼镜店</div>
              </div>
              <div class="top_item_top flex_row flex_2">
                <div class="top_item_inner flex_column">
                  <span>门店运营</span>
                  <span>前台中台</span>
                </div>
                <div class="top_item_inner flex_column">
                  <span>标准管理</span>
                  <span>后台</span>
                </div>
              </div>
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row">详见合同</div>
                <!--            1.8万-->
                <div class="top_item_inner flex_row">NA</div>
              </div>
            </div>
            <div class="top_item flex_column item_pink">
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row">视光中心</div>
              </div>
              <div class="top_item_top flex_row flex_2">
                <div class="top_item_inner flex_column">
                  <span>中心运营</span>
                  <span>前台中台</span>
                </div>
                <div class="top_item_inner flex_column">
                  <span>定制管理</span>
                  <span>后台</span>
                </div>
              </div>
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row">详见合同</div>
                <div class="top_item_inner flex_row">详见合同</div>
                <!--            2.8万  6.8万-->
              </div>
            </div>
            <div class="top_item flex_column item_green">
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row">眼科门诊</div>
              </div>
              <div class="top_item_top flex_row flex_2">
                <div class="top_item_inner flex_column">
                  <span>门诊运营</span>
                  <span>前台中台</span>
                </div>
                <div class="top_item_inner flex_column">
                  <span>医疗管理</span>
                  <span>后台</span>
                </div>
              </div>
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row">详见合同</div>
                <div class="top_item_inner flex_row">详见合同</div>
              </div>
            </div>
            <div class="top_item flex_column item_green">
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row top_item_inner_right">
                  互联网医院
                </div>
              </div>
              <div class="top_item_top flex_row flex_2">
                <div class="top_item_inner flex_column">
                  <span>医院运营</span>
                  <span>前台中台</span>
                </div>
                <div class="top_item_inner flex_column top_item_inner_right">
                  <span>医疗管理</span>
                  <span>后台</span>
                </div>
              </div>
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner flex_row top_item_inner_right">
                  详见合同
                </div>
              </div>
            </div>
          </div>

          <div class="version_top version_top3 flex_row">
            <div class="top_item flex_column item_blue">
              <div class="top_item_top flex_row">
                <div class="top_item_inner top_item_inner_bottom flex_row">
                  费用明细
                </div>
              </div>
            </div>
            <div class="top_item flex_column item_blue">
              <!--              <div class="top_item_top flex_row ">-->
              <!--                <div class="top_item_inner flex_row">设备数据集成</div>-->
              <!--              </div>-->
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row">AI处方</div>
              </div>
              <div class="top_item_top flex_row">
                <div class="top_item_inner top_item_inner_bottom flex_row">
                  年费
                </div>
              </div>
            </div>
            <div class="top_item flex_column item_yellow">
              <!--              <div class="top_item_top flex_row">-->
              <!--                <div class="top_item_inner flex_row">NA-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row">NA</div>
              </div>
              <div class="top_item_top flex_row">
                <div class="top_item_inner top_item_inner_bottom flex_row">
                  0
                </div>
              </div>
            </div>
            <div class="top_item flex_column item_pink">
              <!--              <div class="top_item_top flex_row">-->
              <!--                <div class="top_item_inner flex_row">0.9元/条</div>-->
              <!--              </div>-->
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row">2元/份</div>
              </div>
              <div class="top_item_top flex_row">
                <div class="top_item_inner top_item_inner_bottom flex_row">
                  NA
                </div>
              </div>
            </div>
            <div class="top_item flex_column item_pink">
              <!--              <div class="top_item_top flex_row">-->
              <!--                <div class="top_item_inner flex_row">0.9元/条</div>-->
              <!--              </div>-->
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row">5元/份</div>
              </div>
              <div class="top_item_top flex_row">
                <div class="top_item_inner top_item_inner_bottom flex_row">
                  NA
                </div>
              </div>
            </div>
            <div class="top_item flex_column item_green">
              <!--              <div class="top_item_top flex_row">-->
              <!--                <div class="top_item_inner flex_row">0.9元/条</div>-->
              <!--              </div>-->
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row">25元/份</div>
              </div>
              <div class="top_item_top flex_row">
                <div class="top_item_inner top_item_inner_bottom flex_row">
                  NA
                </div>
              </div>
            </div>
            <div class="top_item flex_column item_green">
              <!--              <div class="top_item_top flex_row">-->
              <!--                <div class="top_item_inner flex_row top_item_inner_right">0.9元/条</div>-->
              <!--              </div>-->
              <div class="top_item_top flex_row">
                <div class="top_item_inner flex_row top_item_inner_right">
                  40元/份
                </div>
              </div>
              <div class="top_item_top flex_row flex_1">
                <div class="top_item_inner top_item_inner_bottom flex_row top_item_inner_right">
                  NA
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="version_body">
          <div class="version_items" v-for="(item, index) in versionData" :key="index">
            <div class="body_title flex_row">
              <div class="title_item flex_row">
                <div class="body_tag flex_row" v-show="item.show" @click="item.show = !item.show">
                  -
                </div>
                <div class="body_tag flex_row" v-show="!item.show" @click="item.show = !item.show">
                  +
                </div>
                <div class="body_info flex_row">{{ item.title }}</div>
              </div>
              <div class="title_item"></div>
              <div class="title_item"></div>
              <div class="title_item"></div>
              <div class="title_item"></div>
            </div>
            <div class="version_item" v-show="item.show">
              <div class="item_left flex_row">
                {{ item.title }}
              </div>
              <div class="item_right" v-show="item.show">
                <div class="body_content">
                  <div class="body_items flex_row" v-for="(item1, index1) in item.contents" :key="index1">
                    <div class="body_item body_item2 flex_row" :class="index1 >= item.contents.length - 1 ? 'body_bottom' : ''
                      ">
                      {{ item1.info }}
                    </div>
                    <div class="body_item flex_row" :class="[
                      index1 >= item.contents.length - 1 ? 'body_bottom' : '',
                      index2 >= item1.tags.length - 1 ? 'body_right' : '',
                      index2 == 0 ? 'body_item2' : '',
                    ]" v-for="(item2, index2) in item1.tags" :key="index2">
                      <img v-show="item2 == 2 ? true : false" src="@/assets/img/version_tag.png" alt="" />
                      <img v-show="item2 == 3 ? true : false" src="@/assets/img/version_star.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="DialogVisibleImg" :visible.sync="dialogVisibleImg" width="85%" style="background: none">
      <iframe boder="0" :src="signStr" style="width: 100%; min-height: 80vh; border: 0">
      </iframe>
    </el-dialog>

    <el-dialog width="50%" :visible.sync="modelShowDialog">
      <div class="flex_row" style="height: calc(100vw * 0.5 * 0.45)">
        <img class="w-full" src="@/assets/img/logo_moban.jpg" alt="" />
      </div>
    </el-dialog>

    <el-dialog width="85%" :visible.sync="dialogVisibleAgree">
      <div class="DialogVisibleAgree">
        <div class="total_title">VISUMALL</div>
        <div class="total_title total_title_intro">中视觉硬件软件系统账号</div>
        <div class="total_title total_title_intro">申请授权使用同意书</div>
        <div class="total_title total_title_intro">目录</div>
        <div class="catalogue">
          <div class="catalogue_item" v-for="(item, aIndex) in AgreeFormArr.Catalogue" :key="aIndex + 'Catalogue'">
            {{ item }}
          </div>
        </div>
        <div class="flex_col empower">
          <div class="flex_row empower_item">
            <div class="flex_row_start empower_left">
              授权方：中视觉健康科技（广州）有限责任公司
            </div>
            <div class="flex_row_start empower_right">申请方：</div>
          </div>
          <div class="flex_row empower_item">
            <div class="flex_row_start empower_left">
              营业地址：广州市海珠区广绣大厦A11座403
            </div>
            <div class="flex_row_start empower_right">营业地址：见营业执照</div>
          </div>
          <div class="flex_row empower_item">
            <div class="flex_row_start empower_left">法定代表人：陈鹏</div>
            <div class="flex_row_start empower_right">
              申请方法人：见营业执照
            </div>
          </div>
          <div class="flex_row empower_item">
            <div class="flex_row_start empower_left">联系人：陈鹏</div>
            <div class="flex_row_start empower_right">申请人姓名：</div>
          </div>
          <div class="flex_row empower_item">
            <div class="flex_row_start empower_left">联系电话：13728031869</div>
            <div class="flex_row_start empower_right">申请方电话：</div>
          </div>
        </div>
        <div class="sign">
          依据《中华人民共和国同意书法》及其他相关法律、行政法规，本着相互信任、真诚合作、共同发展的原则，在友好协商的基础上，就申请方及相关单位购买授权方计算机或移动终端软/硬件最终用户许可达成本同意书（以下简称“本同意书”），并在授权方指定的网络平台签订。
        </div>
        <div class="substance">
          <div class="substance_item" v-for="(item, sIndex) in AgreeFormArr.Substance" :key="sIndex + 'Substance'">
            <div class="substance_title">{{ item.Subtitle }}</div>
            <div class="substance_conten" v-for="(item1, subcontentIndex) in item.Subcontent"
              :key="subcontentIndex + 'subcontent'">
              {{ item1 }}
            </div>
          </div>
        </div>
        <div class="agreen_page">以下无正文，为同意书确认页。</div>
        <div class="flex_col empower" style="font-weight: bold">
          <div class="flex_row empower_item">
            <div class="flex_row_start empower_left">授权方（盖章）：</div>
            <div class="flex_row_start empower_right">申请方：</div>
          </div>
          <div class="flex_row empower_item">
            <div class="flex_row_start empower_left">
              中视觉健康科技（广州）有限责任公司
            </div>
            <div class="flex_row_start empower_right">
              申请方提供的资料：营业执图片
            </div>
          </div>
          <div class="flex_row empower_item">
            <div class="flex_row_start empower_left">
              法定代表人或授权代表（签字）
            </div>
            <div class="flex_row_start empower_right">申请方代表电子签名：</div>
          </div>
          <div class="flex_row empower_item">
            <div class="flex_row_start empower_left">
              同意书签订日期：申请方电子签名日期
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="电子签名" width="700px" :visible.sync="dialogVisibleSign">
      <div class="SignDialog">
        <el-card class="qianming-container" body-style="padding:0px">
          <vue-esign ref="esign" :isCrop="isCrop" :width="600" :height="360" :lineWidth="lineWidth"
            :lineColor="lineColor" :bgColor.sync="bgColor"></vue-esign>
          <div class="contro-container">
            <el-button type="danger" size="mini" @click="handleReset">清空</el-button>
            <el-button type="primary" size="mini" @click="handleGenerate">提交</el-button>
          </div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VDistpicker from "@/components/v-distpicker/Distpicker";
import AreaCascader from "@/components/common/AreaCascader.vue";
import bf from "@/publicFn/baseFn";
import { compressImage } from "@/utils/file";
export default {
  name: "Register",
  components: {
    VDistpicker,
    AreaCascader,
  },
  data() {
    return {
      mg: false,
      isShow: false,
      areaInfo: null, // 选择地区信息
      isBusiness: false,
      srcBusiness: "",
      businessId: "",
      isLogo: false,
      srcLogo: "",
      logoId: "",

      ApplyName: "",
      ApplyId: "",
      ApplyTel: "",
      ApplyPerson: "",
      ApplyRegion: "",
      ApplyProvinceId: "",
      ApplyProvince: "",
      ApplyCityId: "",
      ApplyCity: "",
      ApplyAddress: "",
      ListShop: [{}],
      ApplyVersion: null,
      Version_Channel_Id: "",
      ApplySource: "",
      ApplySourceList: [
        {
          Type: 1,
          Label: "中视觉",
        },
        {
          Type: 2,
          Label: "视无界",
        },
        {
          Type: 3,
          Label: "佩极",
        },
        // {
        //   Type: 4,
        //   Label: "中天",
        // },
        {
          Type: 5,
          Label: "司徕柏",
        },
        // {
        //   Type: 6,
        //   Label: "爱维视",
        // },
        {
          Type: 7,
          Label: "海翔眼科",
        },
        {
          Type: 8,
          Label: "西安中康",
        },
        {
          Type: 9,
          Label: "易视",
        },
      ],
      ApplyVersionList: [],
      // ApplyVersionList: [
      //   { keys: 0, value: "眼镜店版", disabled: false },
      //   { keys: 1, value: "视光中心版", disabled: false },
      //   { keys: 2, value: "门诊版", disabled: false },
      //   { keys: 3, value: "医院版", disabled: false },
      // ],
      ApplyTerm: 10950,
      ApplyTermList: [
        { keys: 0, value: 3, Label: "三天" },
        { keys: 1, value: 365, Label: "一年" },
        { keys: 2, value: 730, Label: "二年" },
        { keys: 3, value: 1095, Label: "三年" },
      ],
      PriceList: [2800, 5800, 15000, 40000],
      versionData: [
        {
          title: "智能营销",
          show: true,
          contents: [
            {
              info: "智能选址",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "设计方案",
              tags: [1, 1, 2, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "设计图纸",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "营销策划",
              tags: [1, 1, 1, 1, 1, 1, 1, 1, 1],
            },
            {
              info: "营销管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "分销设计",
              tags: [1, 1, 2, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "分佣管理",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
          ],
        },
        {
          title: "会员管理",
          show: true,
          contents: [
            {
              info: "会员注册",
              tags: [2, 1, 2, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "家庭账户",
              tags: [1, 1, 2, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "在线支付",
              tags: [1, 1, 2, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "流程进度",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "健康报告",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "分享分销",
              tags: [2, 1, 2, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "积分管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "卡券促销",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
          ],
        },
        {
          title: "筛查系统",
          show: true,
          contents: [
            {
              info: "智能筛查",
              tags: [1, 1, 1, 1, 3, 1, 3, 3, 1],
            },
            {
              info: "近防疾控",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "近防校园",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "近防监管",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "社区筛查",
              tags: [1, 1, 1, 1, 3, 1, 3, 3, 1],
            },
            {
              info: "筛查管理",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
            {
              info: "流量闭环",
              tags: [1, 1, 1, 1, 2, 1, 2, 2, 1],
            },
          ],
        },
        {
          title: "接诊预诊",
          show: true,
          contents: [
            {
              info: "问诊主诉",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "视力检查",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "基础检查",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "电脑验光",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "眼压检查",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "筛查对接",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
          ],
        },
        {
          title: "特检科室",
          show: true,
          contents: [
            {
              info: "裂隙灯检查",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "眼底检查",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "医学验光",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "框架试戴",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "视功能检查",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "检查结论",
              tags: [1, 2, 1, 2, 1, 1, 1, 1, 1],
            },
            {
              info: "眼底诊断",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "角膜地形图",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "眼生物测量",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "角膜内皮镜",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "泪膜检查",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "同视机",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "视野",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "像差分析仪",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
          ],
        },
        {
          title: "专家诊室",
          show: true,
          contents: [
            {
              info: "眼部诊断",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "视光诊断",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "视光方案",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "电子病历",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
          ],
        },
        {
          title: "OK镜验配",
          show: true,
          contents: [
            {
              info: "角膜塑形镜",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
          ],
        },
        {
          title: "治疗训练",
          show: true,
          contents: [
            {
              info: "视觉训练",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "在线训练",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
          ],
        },
        {
          title: "框架定配",
          show: true,
          contents: [
            {
              info: "镜片价目册",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "镜框价目册",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "定制参数建模",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "3D打印镜框",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
          ],
        },
        {
          title: "结算中心",
          show: true,
          contents: [
            {
              info: "结算中心",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "进销存",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
          ],
        },
        {
          title: "眼病转诊",
          show: true,
          contents: [
            {
              info: "白内障",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "青光眼",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "屈光手术",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "干眼诊疗",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "眼底病",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "小儿斜弱视",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
          ],
        },
        {
          title: "健康管理中心",
          show: true,
          contents: [
            {
              info: "健康报告",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "电子病历",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "OK镜报告",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "训练报告",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "框架镜报告",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
          ],
        },
        {
          title: "门诊运营管理",
          show: true,
          contents: [
            {
              info: "门诊管理",
              tags: [1, 1, 1, 1, 1, 1, 2, 2, 1],
            },
            {
              info: "营销管理",
              tags: [1, 1, 1, 1, 1, 1, 2, 2, 1],
            },
            {
              info: "绩效管理",
              tags: [1, 1, 1, 1, 1, 1, 2, 2, 1],
            },
            {
              info: "流程定制",
              tags: [1, 1, 1, 1, 1, 1, 2, 2, 1],
            },
            {
              info: "顾客管理",
              tags: [1, 1, 1, 1, 1, 1, 2, 2, 1],
            },
            {
              info: "智慧运营",
              tags: [1, 1, 1, 2, 1, 1, 1, 2, 1],
            },
            {
              info: "集团架构",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "排班管理",
              tags: [1, 1, 1, 1, 1, 1, 2, 2, 1],
            },
            {
              info: "价目册",
              tags: [1, 2, 1, 2, 1, 1, 2, 2, 1],
            },
            {
              info: "推荐设置",
              tags: [1, 1, 1, 1, 1, 1, 2, 2, 1],
            },
            {
              info: "销售管理",
              tags: [1, 1, 1, 1, 1, 1, 2, 2, 1],
            },
            {
              info: "订单管理",
              tags: [1, 1, 1, 1, 1, 1, 2, 2, 1],
            },
          ],
        },
        {
          title: "科普演示",
          show: true,
          contents: [
            {
              info: "眼科疾病",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "方案演示",
              tags: [2, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "产品演示",
              tags: [2, 2, 1, 2, 1, 2, 1, 2, 1],
            },
          ],
        },
        {
          title: "ERP管理",
          show: true,
          contents: [
            {
              info: "权限管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "操作日志",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "人力资源",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "客户管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "进货管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "零售管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "库存管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "财务管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "报表管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
          ],
        },
        {
          title: "连锁体系\n四级架构",
          show: true,
          contents: [
            {
              info: "总部架构",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "批发管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "分级结算",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "商品共享",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "加盟管理",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "统购平台",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
            {
              info: "连锁财务",
              tags: [1, 1, 2, 1, 2, 1, 2, 1, 2],
            },
          ],
        },
        {
          title: "智能CRM",
          show: true,
          contents: [
            {
              info: "预约挂号",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "叫号信息",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "我的支付",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "我的报告",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "智能随访",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "家庭医生",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "健康管理",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "我的分享",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "重要通知",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "体检筛查",
              tags: [1, 2, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "视觉训练",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "自测问诊",
              tags: [1, 2, 1, 2, 1, 2, 1, 2, 1],
            },
          ],
        },
        {
          title: "远程诊疗",
          show: true,
          contents: [
            {
              info: "专家绩效",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "排班计划",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "预约管理",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "远程会诊",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "论文课题",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "患者管理",
              tags: [1, 1, 1, 1, 1, 2, 1, 2, 1],
            },
            {
              info: "差评管理",
              tags: [1, 1, 1, 2, 1, 2, 1, 2, 1],
            },
            {
              info: "远程诊疗",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "药房管理",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
          ],
        },
        {
          title: "眼科PACS",
          show: true,
          contents: [
            {
              info: "电脑验光",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "眼压",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "眼底诊断",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "眼生物测量",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
            {
              info: "角膜地形图",
              tags: [1, 1, 1, 1, 1, 1, 1, 2, 1],
            },
          ],
        },
      ],
      dialogVisible: false,
      dialogVisibleImg: false,
      Agree: "",
      dialogVisibleAgree: false,
      AgreeFormArr: {
        Catalogue: [
          "目录",
          "第一条 特许使用软/硬件和平台配套硬件",
          "第二条 许可授权",
          "第三条 价格清单和支付方式",
          "第四条 交付和售后服务",
          "第五条 著作权及知识产权",
          "第六条 声明及产品保证",
          "第七条 责任限制与违约责任",
          "第八条 保密信息",
          "第九条 不可抗力",
          "第十条 通知",
          "第十一条 同意书解除",
          "第十二条 争议解决",
          "第十三条 同意书签订及期限",
        ],
        Substance: [
          {
            Subtitle: "第一条 特许使用软/硬件和平台配套硬件",
            Subcontent: [
              "授权方愿意向申请方提供“VISUMALL智慧眼健康信息系统”的最终用户许可使用权，授权方愿意根据申请方的需要，向申请方提供配合应用的软/硬件和平台配套硬件。",
            ],
          },
          {
            Subtitle: "第二条许可授权",
            Subcontent: [
              "申请方被授权许可销售使用的软/硬件的范围限于：",
              "申请方获得的授权有效期：本同意书有效执行下永久有效。",
              "2.1根据本同意书约定的条款及条件，授权方同意授予且申请方同意接受对本同意书约定的许可软件的非专有的、不可转让的使用许可。包括：",
              "1)在本同意书指定的范围及计算机或移动终端系统内安装并使用许可软件。且可以按照申请方要求在系统的呈现界面上使用申请方的标志和 LOGO 等元素。",
              "2)按照许可资料的说明配置许可软/硬件。",
              "2.2使用许可的范围",
              "1)申请方可以在网络或多用户环境下使用许可软/硬件，包括提供远程终端、通过网络共享及本地所有服务器、客户机、联机终端、独立节点或工作站， 但使用许可软/硬件的许可单位数量不得超过本同意书中规定的许可数。",
              "2)若申请方需要在超出本同意书规定的使用范围或许可数以外使用许可软/硬件，应向授权方提出申请，另行签署使用许可同意书并支付相应软/硬件使用许可费用后才能在新增的使用范围或许可数范围内使用。",
              "2.3许可的限制",
              "未经授权方事先书面许可，申请方不得实施以下行为：",
              "1)将许可软/硬件向其他第三方提供、销售、出租、出借、转让或提供分许可、转许可、通过信息网络传播或以其他形式供他人利用。",
              "2)对许可软/硬件进行全部或部分地翻译、分解、反向编译、反汇编、反向工程或其他试图从许可软/硬件导出程序源代码的行为，或在许可软/硬件的基础上书写或开发衍生软/硬件、衍生产品或其他软/硬件。",
              "3)限制、破坏或绕过许可软/硬件附带加密附件或授权方提供的其他确保许可软/硬件正确使的限制性措施。",
              "4)将许可软/硬件用于除申请方使用以外的其他目的，包括但不限于向第三方商业共享或软/硬件共享安排。",
              "5)除掉、掩盖或更改许可软/硬件上有关许可软/硬件著作权或商标的标志。",
              "6)破解、规避授权方软/硬件的技术保护措施。",
              "7)自行安装非授权方认可的硬件（自行购买的非授权方硬件在安装前需要跟授权方确认型号）。",
            ],
          },
          {
            Subtitle: "第三条 价格清单和支付方式",
            Subcontent: [
              "（一）申请方购买软件费用清单：",
              "3.1  软件使用授权初装费：眼视光门店专业运营系统使用授权初装费是以门店为单位的一次性费用，含税价格人民币   元/门店（大写：壹万捌仟元整）暂免。",
              "3.1.1 软件使用年度维护费用： 元/门店/年（大写：贰仟元整）暂免。",
              "3.2  系统使用费用（系统授权使用费包含：对应版本的全部功能营销前台，业务中台，管理后台，AI辅助诊断和AI处方费用，头部3D配镜参数测量硬件）：",
              "眼镜门店的收费标准：人民币2.0元/份报告（大写：贰元整）。",
              "视光中心的收费标准：人民币5.0元/份报告，(大写：伍元整）111。",
              "眼科门诊的收费标准: 人民币 10.0元/份报告，(大写：伍元整）。",
              "3.2.1 申请方开通的有偿使用眼视光设备的AI辅助诊断和处方功能（液晶视力表，电脑验光,综合验光，视功能检查，眼轴测量，眼压测量等视光设备），费用按照每人次眼视光AI处方报告收取，提前储值，使用扣减，生成诊断和处方结果的同时系统自动完成计费.",
              "3.3 设备对接条件如下：",
              "3.3.1 经过授权方工程技术人员确认后的申请方可对接设备；",
              "3.3.2 申请方必须确保设备厂商按照授权方要求配合提供相关设备的软硬件接口和设置；",
              "3.3.3 授权方申请方双方确认需要可对接的设备数量后，申请方方可申请相关PACS的硬件和程序用以配置对接。",
              "3.3.5 授权方提供远程支持操作相关的对接软硬件安装，如需授权方提供上门安装对接服务的，申请方需要承担授权方人员差旅费用；",
              "3.4 申请方可以申请开通有偿使用全眼科设备（眼底诊断，数码裂隙灯，OCT断层扫描仪，角膜地形图，眼生物测量仪等）的AI诊断和AI处方，授权方申请方双方根据实际需求确认后，则需另外签署合作协议后方可展开全眼科AI辅助诊断和处方的专业技术服务。",
              // "3.5 本同意书的 3.2条款和3.4条款，申请开通条件：",
              "此两项条款每个门店为单位可任意储值达到人民币5,000元（大写：伍仟元整）即可以获得即可以获得该门店的软件程序的授权安装使用；",
              "3.5 支付方式：授权方收到申请方申请内容的全额款项后24小时内开通",
              "3.5.1 授权方收款账号，在线支付将以授权方的收款凭证为准。",
              "开户银行：民生银行广州天河北支行",
              "户" +
              "\xa0\xa0\xa0\xa0\xa0\xa0\xa0" +
              "名：中视觉健康科技（广州）有限责任公司",
              "账" + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + "号：698113686",
            ],
          },
          {
            Subtitle: "第四条 交付和售后服务",
            Subcontent: [
              "4.1．项目启动和交付期限：本同意书生效并收到约定款项后 3 个工作日内启动项目。",
              "授权方向申请方交付的许可软/硬件资料包括：用户操作手册和操作视频在线资料。",
              "4.2．交付地点：根据申请方指定的地点交付安装。",
              "4.3.授权方提供的免费远程培训服务，远程培训需要提前预约，若需要申请方需要提供上门培训服务，上门服务的全部费用由申请方负责承担：工时费1500 元/人/天,授权方技术人员和培训老师的差旅费实报实销。",
              "4.4. 在申请方及相关单位正确操作的情况下，授权方确保已验收交付的系统和产品在申请方服务器环境能稳定运行；如申请方在运行中出现授权方系统和产品程序缺陷和稳定性问题导致的运行异常，授权方需要在 24 小时内响应并解决（可以远程电话，视频，邮件，现场等方式进行）。",
            ],
          },
          {
            Subtitle: "第五条 著作权及知识产权",
            Subcontent: [
              "5.1著作权",
              "申请方承认许可软/硬件及与许可软/硬件有关的源代码、目标代码、文档资料以及任何由授权方根据相关专业服务提供的软/硬件、资料的著作权或合法授权获得使用均归中视觉健康科技（广州）有限责任公司所有，并受《中华人民共和国著作权法》和其他有关法律、法规的保护。除本同意书的约定的特许使用权以外，授权方未向申请方授予与许可软/硬件著作权、专利权、商标专用权、商业秘密及其他权利有关的任何权利。",
              "5.2知识产权保证",
              "1)授权方保证在本同意书生效之日，许可软/硬件不侵犯任何第三方的专利权、著作权、商标专用权、商业秘密及其他权属权利。",
              "2)申请方因在本同意书项下使用该许可软/硬件，而导致第三方对申请方提起诉讼或控告，指控申请方侵犯其著作权、专利权、商标专用权或商业秘密等合法权利，申请方应立即将任何此类索赔以书面形式通知授权方。未经授权方事先书面同意，申请方不得就此类索赔做出任何不利于或可能不利于授权方承诺。否则申请方将承担此类索赔的处理结果。如果处理此类索赔过程中需要授权方参与处理或直接处理时，申请方应给予授权方明确的授权并得到授权方的接受，申请方同意就此向授权方提供合理的协助，且因此产生的相关费用由授权方承担。如果授权方拒绝协助或处理，导致的侵权事件处理结果应有授权方承担。",
              "3)如果前述款项所述侵权是因除授权方或授权方合法代理人以外的人对许可软/硬件修改、改动、增加所造成的，授权方不承担任何法律责任。",
            ],
          },
          {
            Subtitle: "第六条 声明及产品保证",
            Subcontent: [
              "6.1声明",
              "1)申请方保证具有完全的权利或充分的授权签署并履行本同意书，其按照本同意书的约定履行义务的行为不会违反申请方在其他同意书项下所承担的义务。",
              "2)授权方保证具有完全的权利或充分的授权签署并履行本同意书，其按照本同意书的约定履行义务的行为不会违反授权方在其他同意书项下所承担的义务。",
              "6.2产品保证",
              "1)账户唯一性的保证:",
              "Visumall 的 app 的加密方式是在移动终端的唯一使用设定,由申请方自己设定管理，任何非账户端的泄密使用都会出现即时冲突提醒而锁定非法使用端，以此保护合法用户的唯一性和权益。",
              "2）产品质量保证：授权方保证交付的软/硬件符合申请方实际购买产品模块对应用户操作手册所述功能。",
              "3）硬件设备的质量保证均为一年免费保修（非申请方责任的故障），保修期内的上门维修和返厂费用由授权方负责，保修期以外的任何故障所需的上门维修服务和返厂维修的费用根据实际发生，由申请方承担相关费用。",
            ],
          },
          {
            Subtitle: "第七条 责任限制与违约责任",
            Subcontent: [
              "双方应本着友好合作的态度履行各自同意书义务，任何一方均不得单方面解除该同意书。申请方违反本同意书约定的许可软/硬件使用许可限制、声明与保证等他同意书义务，授权方可以立即解除本同意书，终止对申请方的使用许可，并要求申请方赔偿授权方因此受到的全部损失。",
            ],
          },
          {
            Subtitle: "第八条 保密信息",
            Subcontent: [
              "授权方申请方双方承认保密信息构成有价值的商业秘密。双方同意严格按照本同意书的规定使用对方的保密信息。双方同意：",
              "8.1.对保密信息保密，并采取所有必要的预防措施（包括但不限于双方采取的用于保护自身保密信息的措施）防止未经授权地使用及透露保密信息。不得向第三方提供保密信息或由保密信息衍生的信息。本同意书双方所承担的保密义务不因本同意书的变更、终止而终止，如双方没有对保密期限加以规定，则直至保密信息成为公知信息后，本同意书约定的保密义务才予以解除。",
              "8.2.本同意书所称的商业秘密是指不为公众知悉、能带来经济利益、具有实用性的技术信息和经营信息，包括但不限于：申请方委托授权方定制开发并且拥有知识产权保护的技术：（产品设计新产品研发过程及成果、经营计划及策略、客户资料、货源信息、采购资料、成本数据、定价政策、商品价格、销售（进货）渠道、函电、同意书、单据、营销策略、财务数据以及与申请方签订加盟合作的第三方相关网点信息、销售数据、财务数据、客户信息等）。",
              "8.3.任何时候，只要收到商业秘密拥有方的书面要求，接受方应立即归还全部商业秘密资料和文件，包含该商业秘密的媒体及其任何或全部复印件或摘要。如果该技术资料属于不能归还的形式，或已经复制、转录到其他资料或载体中，则应删除；无论任何原因，服务终止后，接收方不可恢复已删除服务器上的任何保密信息，并不留存副本。",
              "8.4.因泄密行为给对方造成损失的，由双方本着诚信、务实的原则进行协商。各方在此确认，由于泄露商业秘密给对方造成的损失可能非常重大以致无法估量，违约方应当至少向对方同意书金额0.02%违约金，并且在可能的前提下，应当尽可能防止信息进一步泄密。违约方还应当承担对方为维权支付的合理费用，包括但不限于律师费、诉讼费、公证费、差旅费、保全费等。",
            ],
          },
          {
            Subtitle: "第九条 不可抗力",
            Subcontent: [
              "9.1.同意书的任何一方因不能预见、无法避免的自然灾害或社会事件，包括但不限于战争、港口封锁、内乱以及严重的水灾、地震和其他国际商务惯例被认定的不可抗力事故而影响同意书执行时，则延迟履行同意书的期限，延迟的时间应相当于不可抗力事故所影响的时间。",
              "9.2.同意书的任何一方因不可抗力的原因，不能履行同意书，应及时通知对方，在取得有关部门的证明和对方谅解的情况下，经双方协商一致，可延期履行同意书，或更改同意书中的某些条款。",
              "9.3.同意书双方如果出现永久性运营中断或者非同意书法人主体运营服务器数据中心的情况，需要提前 30 天通知对方，同时协商确保服务器数据中心可以安全正常运行方案，任何一方都必须保证本同意书约定的知识产权权益和数据保密协议得到有效执行，否则将承担违约责任。",
            ],
          },
          {
            Subtitle: "第十条 通知",
            Subcontent: [
              "各方基于本同意书向对方发出的所有书面通知均应按本同意书首部约定的地址及联系人发出，任何一方上述信息发生变化时，均应及时通知对方，否则由此产生的不利后果由变更方承担。",
            ],
          },
          {
            Subtitle: "第十一条 同意书解除",
            Subcontent: ["双方经过协商一致，可以解除本同意书。"],
          },
          {
            Subtitle: "第十二条 争议解决",
            Subcontent: [
              "凡由本同意书引起的或与解释或执行本同意书有关的任何争议，各方应首先通过友好协商或调解解决。协商或调解不成，可提交原告方所在地人民法院诉讼解决。",
            ],
          },
          {
            Subtitle: "第十三条 同意书签订及期限",
            Subcontent: [
              "本同意书自申请方电子签名开始生效，并持续有效直至根据本同意书的约定而终止。本同意书电子版保存，具有纸质版同等法律效力。本同意书附件为本同意书的组成部分，具有与本同意书同等的法律效力。",
            ],
          },
        ],
      },
      dialogVisibleSign: false,
      lineWidth: 2,
      lineColor: "#000000",
      bgColor: "#ffffff",
      srcSign: "",
      isCrop: true,
      srcSignId: "",
      signStr: "",
      trueSrcSign: "",
      modelShowDialog: false,
    };
  },
  created() {
    // this.ApplyVersion = 0;
    this.dialogVisible = false;
    this.dialogVisibleImg = false;
    this.dialogVisibleSign = false;
    this.modelShowDialog = false;
    this.srcSignId = "";
    this.srcSign = "";
    this.trueSrcSign = "";
    // if(this.$route.query.item) {
    //   this.ApplyVersion = parseInt(this.$route.query.item);
    // }
    // this.changeApplyVersion(this.ApplyVersion);
  },
  methods: {

    // 处理同步门店信息
    handleSyncShopInfo(index) {
      this.$set(this.ListShop, index, {
        ApplyName: this.ApplyName,
        ApplyTel: this.ApplyTel,
        ApplyPerson: this.ApplyPerson,
        ApplyAddress: this.ApplyAddress,
        ApplyExpertTel: this.ApplyTel,
        areaInfo: this.areaInfo
      })
    },
    getNowDate() {
      const timeOne = new Date();
      const year = timeOne.getFullYear();
      let month = timeOne.getMonth() + 1;
      let day = timeOne.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      const NOW_MONTHS_AGO = `${year}-${month}-${day}`;
      return NOW_MONTHS_AGO;
    },
    agreenClick() {
      this.dialogVisibleImg = true;
      let ApplyDate = this.getNowDate();
      this.signStr = `https://ow.visumall.com/public/SignView.html?ApplyName=${this.ApplyName}&ApplyPerson=${this.ApplyPerson}&ApplyTel=${this.ApplyTel}&ApplyDate=${ApplyDate}&SrcSign=${this.trueSrcSign}`;
      console.log(this.signStr);
    },
    goVersion() {
      //?ApplyName=公司&ApplyPerson=王王&ApplyTel=14789950963&ApplyDate=123&SrcSign=https://zsjreportpic.oss-cn-shenzhen.aliyuncs.com/CompanyLic/a69b27fc-2eb6-976a-f2f8-f4b6acc6952d/a69b27fc-2eb6-976a-f2f8-f4b6acc6952d_1661422945056.png?Expires=1661424145&OSSAccessKeyId=LTAI4G4K3qwoPDVheUPERDZH&Signature=Jo96NMBiZ%2B5%2FiOvxIKuCwG4ksoY%3D
      this.dialogVisible = true;
      // this.$router.push({path: '/VersionDifferent'});
    },
    async changeApplySource(val) {
      try {
        this.ApplyVersion = null;
        const res = await this._api.userCurdApi.getVersionList({
          Channel_No: val,
        });
        // 过滤版本
        if (res.Result?.Channel_Versions) {
          this.Version_Channel_Id = res.Result?.Channel_Id;
          const list = [
            { keys: 0, value: "眼镜店版" },
            { keys: 1, value: "视光中心版" },
            { keys: 2, value: "门诊版" },
            { keys: 3, value: "医院版" },
          ];
          this.ApplyVersionList = list.filter((v) =>
            res.Result?.Channel_Versions.includes(v.keys)
          );
        } else {
          this.ApplyVersion = null;
          this.ApplyVersionList = [];
        }
      } catch (error) {
        console.log("error");
      }
    },
    close() {
      this.mg = !this.mg;
    },

    checkData() { },

    cancel() {
      this.$router.go(-1);
    },

    submit() {
      if (!this.Agree) {
        this.$alert("请勾选授权使用同意书", "提示");
        return;
      }
      if (!this.ApplyName) {
        this.$alert("公司名称为空", "提示");
        return;
      }
      if (!this.ApplyTel) {
        this.$alert("公司手机号码为空", "提示");
        return;
      }
      if (!this.ApplyPerson) {
        this.$alert("联系人为空", "提示");
        return;
      }
      if (!this.areaInfo) {
        this.$alert("省/市为空", "提示");
        return;
      }
      if (!this.ApplyAddress) {
        this.$alert("详细地址为空", "提示");
        return;
      }
      if (!this.srcBusiness) {
        this.$alert("请提交营业执照", "提示");
        return;
      }
      if (!this.srcLogo) {
        this.$alert("请提交公司Logo", "提示");
        return;
      }
      if (this.ApplySource == "") {
        this.$alert("请提交渠道编码", "提示");
        return;
      }

      if (this.ApplyVersion === null || this.ApplyVersion === undefined || this.ApplyVersion === "") {
        return this.$alert("请选择申请版本", "提示");
      }

      if (!this.srcSign) {
        this.$alert("必须提交电子签名", "提示");
        return;
      }
      if (this.ListShop.length <= 0) {
        this.$alert("必须添加门店信息喔", "提示");
        return;
      }
      console.log(this.ListShop);
      for (let i = 0; i < this.ListShop.length; i++) {
        if (
          !this.ListShop[i].ApplyName ||
          !this.ListShop[i].ApplyTel ||
          !this.ListShop[i].ApplyPerson ||
          !this.ListShop[i].areaInfo ||
          !this.ListShop[i].ApplyAddress ||
          !this.ListShop[i].ApplyExpertTel
          // !this.ListShop[i].srcStore
        ) {
          this.$alert("门店信息有空", "提示");
          return;
        }
      }
      let lo = this.$loading({
        text: "注册中...",
        background: "rgba(0, 0, 0, 0.8)",
      });

      // 门店信息
      const ListShop = this.ListShop.map((item) => ({
        ApplyId: item.ApplyId,
        ApplyName: item.ApplyName,
        ApplyTel: item.ApplyTel,
        ApplyPerson: item.ApplyPerson,
        ApplyRegion: item.areaInfo?.text,
        ApplyProvinceId: item.areaInfo?.provinceId,
        ApplyProvince: item.areaInfo?.provinceName,
        ApplyCityId: item.areaInfo?.cityId,
        ApplyCity: item.areaInfo?.cityName,
        ApplyAddress: item.ApplyAddress,
        ApplyExpertTel: item.ApplyExpertTel,
        isStore: item.isStore,
        srcStore: item.srcStore,
        storeId: item.storeId,
      }));
      this._api.userCurdApi
        .ApplyInsert(
          this.ApplyId,
          this.ApplyName,
          this.ApplyTel,
          this.ApplyPerson,
          this.areaInfo?.provinceId, // 省级id
          this.areaInfo?.provinceName, // 省级名称
          this.areaInfo?.cityId, // 市级id
          this.areaInfo?.cityName, // 市级名称
          this.ApplyAddress,
          ListShop,
          this.ApplyVersion,
          this.Version_Channel_Id, // ApplySource
          this.ApplyTerm
        )
        .then((res) => {
          lo.close();
          if (res.InsertResult !== 0) {
            this.$store.commit("bases/upApplyId", res.Id);
            this.$store.commit("bases/upApplyTel", this.ApplyTel);
            this.$alert("注册成功", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.go(-1);
              },
            });
          } else {
            if (res.msg == "Exists") {
              this.$alert("手机号已被注册过！", "提示");
            } else {
              this.$alert(res.msg, "提示");
            }
          }
        })
        .catch((error) => {
          lo.close();
          this.$alert(error, "提示");
        });
    },

    add() {
      this.ListShop.push({});
    },
    getImageLimit(fileSize) {
      let limit = fileSize / 1024 / 1024;
      if (limit > 5) {
        return true;
      } else {
        return false;
      }
    },

    async getFileProcess(e, type, index = 0) {
      //附件预览----合同及其他扫描件
      let _this = this;
      let files = e.target.files[0];
      let ufType = "CompanyLogo";
      const isIMAGE =
        files.type === "image/jpeg" ||
        files.type === "image/png" ||
        files.type === "image/gif";
      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式!");
        return false;
      }
      if (this.getImageLimit(files.size)) {
        let message = "";
        if (type == "business") {
          message = "图片过大，请重新提交营业执照";
        } else if (type == "logo") {
          message = "图片过大，请重新提交公司Logo";
        } else {
          message = "图片过大，请重新提交门头照片";
        }
        this.$alert(message, "提示");
        return;
      }
      let splitType = files.name.split(".");
      let srcType = "." + splitType[splitType.length - 1];
      if (!e || !window.FileReader) return; // 看支持不支持FileReader
      // let reader = new FileReader();
      // reader.readAsDataURL(files); // 这里是最关键的一步，转换就在这里
      let flag = false;
      let deleteId = "";
      // reader.onloadend = function () {

      // };
      const dataUrl = await compressImage(files, 0.5);
      if (type == "business") {
        if (_this.srcBusiness) {
          flag = true;
          deleteId = _this.businessId;
        }
        _this.srcBusiness = dataUrl;
        _this.isBusiness = true;
        ufType = "CompanyLic";
      } else if (type == "logo") {
        if (_this.srcLogo) {
          flag = true;
          deleteId = _this.logoId;
        }
        _this.srcLogo = dataUrl;
        _this.isLogo = true;
        ufType = "CompanyLogo";
      } else {
        if (_this.ListShop[index].srcStore) {
          flag = true;
          deleteId = _this.ListShop[index].storeId;
        }
        _this.ListShop[index].srcStore = dataUrl;
        _this.ListShop[index].isStore = true;
        _this.setData(index);
        ufType = "ShopPic";
      }

      let UFReId = bf.getGuid();
      if (type == "business" || type == "logo") {
        if (!_this.ApplyId) {
          _this.ApplyId = UFReId;
        }
        UFReId = _this.ApplyId;
      } else {
        if (!_this.ListShop[index].ApplyId) {
          _this.ListShop[index].ApplyId = UFReId;
        }
        UFReId = _this.ListShop[index].ApplyId;
      }
      if (flag) {
        console.log("deleteId = " + deleteId);
        _this._api.userCurdApi.UploadFileDeleteById(deleteId).then((res) => {
          //删除成功
          if (res.DeleteByIdReturn !== 0) {
            //加载图片
            _this.upLoadFile(
              type,
              dataUrl,
              UFReId,
              "Apply",
              srcType,
              ufType,
              "OSSPrivate",
              index
            );
          } else {
            // _this.alert('删除失败','提示')
            console.log("删除失败");
          }
        });
      } else {
        _this.upLoadFile(
          type,
          dataUrl,
          UFReId,
          "Apply",
          srcType,
          ufType,
          "OSSPrivate",
          index
        );
      }
    },

    upLoadFile(
      type,
      result,
      UFReId,
      Apply,
      srcType,
      ufType,
      OSSPrivate,
      index = 0
    ) {
      let _this = this;
      this._api.userCurdApi
        .UploadFileUpload(
          result.split(",")[1],
          UFReId,
          Apply,
          srcType,
          ufType,
          OSSPrivate
        )
        .then((res) => {
          if (res.msg == "Success") {
            if (type == "business") {
              _this.businessId = res.Id;
            } else if (type == "logo") {
              _this.logoId = res.Id;
            } else if (type == "companySign") {
              _this.srcSignId = res.Id;
              _this.trueSrcSign = res.FullURL;
            } else {
              _this.ListShop[index].storeId = res.Id;
            }
          }
        });
    },

    setData(index) {
      this.$set(this.ListShop, index, {
        areaInfo: this.ListShop[index].areaInfo,
        ApplyRegion: this.ListShop[index].areaInfo?.text,
        ApplyProvinceId: this.ListShop[index].areaInfo?.provinceId,
        ApplyProvince: this.ListShop[index].areaInfo?.provinceName,
        ApplyCityId: this.ListShop[index].areaInfo?.cityId,
        ApplyCity: this.ListShop[index].areaInfo?.cityName,
        isShow: this.ListShop[index].isShow,
        ApplyName: this.ListShop[index].ApplyName,
        ApplyTel: this.ListShop[index].ApplyTel,
        ApplyPerson: this.ListShop[index].ApplyPerson,
        ApplyAddress: this.ListShop[index].ApplyAddress,
        ApplyExpertTel: this.ListShop[index].ApplyExpertTel,
        isStore: this.ListShop[index].isStore,
        srcStore: this.ListShop[index].srcStore,
        storeId: this.ListShop[index].storeId,
        ApplyId: this.ListShop[index].ApplyId,
      });
    },

    showDivWrap(index) {
      this.ListShop[index].isShow = !this.ListShop[index].isShow;
      this.setData(index);
    },

    checkPhone(iphone, type, index = 0) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(iphone)) {
        //alert("手机号码有误，请重填");
        this.$alert("手机号码有误，请重填", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (type == 1) {
              this.ApplyTel = "";
            } else if (type == 2) {
              this.ListShop[index].ApplyTel = "";
            } else if (type == 3) {
              this.ListShop[index].ApplyExpertTel = "";
            }
          },
        });
      }
    },
    delectClick(e) {
      let index = e.target.dataset.index;
      this.ListShop.splice(parseInt(index), 1);
    },

    resSignUpLoadFile(type) {
      let UFReId = bf.getGuid();
      if (!this.ApplyId) {
        this.ApplyId = UFReId;
      }
      UFReId = this.ApplyId;
      if (type == "delect") {
        if (!this.srcSignId) return;
        this._api.userCurdApi
          .UploadFileDeleteById(this.srcSignId)
          .then((res) => {
            //删除成功
            if (res.DeleteByIdReturn !== 0) {
              //加载图片
              this.srcSignId = "";
            } else {
              // _this.alert('删除失败','提示')
              console.log("删除失败");
            }
          });
      } else {
        if (this.srcSignId) {
          this._api.userCurdApi
            .UploadFileDeleteById(this.srcSignId)
            .then((res) => {
              //删除成功
              if (res.DeleteByIdReturn !== 0) {
                //加载图片
                this.upLoadFile(
                  "companySign",
                  this.srcSign,
                  UFReId,
                  "Apply",
                  ".png",
                  "CompanySign",
                  "OSSPrivate"
                );
              } else {
                // _this.alert('删除失败','提示')
                console.log("删除失败");
              }
            });
        } else {
          this.upLoadFile(
            "companySign",
            this.srcSign,
            UFReId,
            "Apply",
            ".png",
            "CompanySign",
            "OSSPrivate"
          );
        }
      }
    },
    handleReset() {
      this.$refs.esign.reset();
      this.srcSign = "";
      this.resSignUpLoadFile("delect");
    },
    //生成签名图片..
    handleGenerate() {
      this.$refs.esign
        .generate()
        .then((res) => {
          this.srcSign = res;

          this.dialogVisibleSign = false;
          this.resSignUpLoadFile("upload");
          //resultImgId
        })
        .catch((err) => {
          this.$message.error("请签名之后提交！");
        });
    },
    //将base64转换为文件..
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
  },
};
</script>

<style scoped lang="scss">
.Register {
  width: 100vw;
  min-width: 1024px;
  height: 100vh;
  position: relative;

  .back {
    width: 100%;
  }

  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #b6b6b6;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #b6b6b6;
    // font-size: 1.8rem;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #b6b6b6;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #b6b6b6;
  }

  ::v-deep .el-checkbox__inner {
    border: 1px solid #409eff;
  }

  //点击上传的样式 start
  .upfile_content {
    //flex_row style="width: 60%"
    justify-content: flex-start;

    .fileBox {
      //flex_row
      justify-content: flex-start;

      .fileinput-button {
        //flex_row  style="width: 1.6rem; height: 1.6rem; background-size: 1.6rem auto;"
        float: left;
        position: relative;
        display: inline-block;
        overflow: hidden;
        background: url(../../../assets/img/gw_add.png) no-repeat;
        background-position: center center;

        input {
          position: absolute;
          left: 0px;
          top: 0px;
          opacity: 0;
          -ms-filter: "alpha(opacity=0)";
        }
      }
    }

    .fileBox-word {
      // style="height: 1.6rem; line-height: 1.6rem; color: #B6B6B6; font-size: 0.48rem;"
    }
  }

  //点击上传的样式 end
  .button {
    height: 0.5rem;
    line-height: 0.5rem;
  }

  .sr {
    position: absolute;
    width: 96%;
    margin: 2% 2%;

    .sr_title {
      padding: 0.07rem 0.21rem;
      text-align: left;
      font-weight: 500;
      // font-size: 0.16rem;
      background: rgba(255, 255, 255, 0.83);
    }

    .sr_body {
      margin-top: 0.03rem;
      background: rgba(255, 255, 255, 0.83);

      .company,
      .store {
        padding-top: 0.17rem;

        .cp_title,
        .se_title {
          text-align: left;

          span {
            font-weight: bold;
            background: #97cbff;
            padding: 0.07rem 0.33rem;
            // font-size: 0.15rem;
            color: #000000;
          }
        }

        .cp_items {
          margin-top: 0.13rem;

          .cp_item {
            flex: 1;

            .item_info {
              margin-left: 0.28rem;
              text-align: left;
              width: 1.5rem;
              // font-size: 0.15rem;
              font-weight: bold;
              color: #808080;
            }

            .item_info1 {
              margin-left: 0.28rem;
              text-align: left;
              // font-size: 0.15rem;
              font-weight: bold;
              color: #808080;
            }

            .item_input {
              flex: 1;
              justify-content: flex-start;

              input {
                padding: 0.01rem 0;
                border: none;
                outline: none;
                background: transparent;
                // font-size: 0.14rem;
                width: 90%;
                height: 0.5rem;
                line-height: 0.5rem;
                //font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .item_content {
              justify-content: flex-start;

              .fileBox {
                justify-content: flex-start;

                .fileinput-button {
                  float: left;
                  position: relative;
                  display: inline-block;
                  overflow: hidden;
                  background: url(../../../assets/img/gw_add.png) no-repeat;
                  background-size: 0.4rem auto;
                  background-position: center center;

                  input {
                    position: absolute;
                    left: 0px;
                    top: 0px;
                    opacity: 0;
                    -ms-filter: "alpha(opacity=0)";
                  }
                }
              }

              .fileBox-word {
                height: 0.4rem;
                line-height: 0.4rem;
                color: #b6b6b6;
                // font-size: 0.12rem;
              }
            }
          }
        }
      }

      .store {
        padding-top: 0.5rem;

        .store_top {
          justify-content: space-between;

          .informDiv {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .inform {
              margin-right: 0.28rem;
              padding: 0.09rem 0.18rem;
              border: 0.01rem solid #fda100;
              border-radius: 0.11rem;
              // font-size: 0.13rem;
              font-weight: 500;
            }
          }
        }

        .store_content {
          width: 98%;
          margin: 0.2rem auto 0;

          .content_top {
            background: #dddddd;

            div {
              padding: 0.12rem 0;
              flex: 2;
              // font-size: 0.15rem;
              font-weight: 500;
            }
          }

          .content_body {
            height: 1.75rem;
            overflow-y: auto;

            //overflow: hidden;
            .store_items {
              padding: 0.08rem 0;
              background: #fff;

              .store_item {
                flex: 2;

                input {
                  padding: 0.01rem 0;
                  text-align: center;
                  width: 100%;
                  border: none;
                  outline: none;
                  background: transparent;
                  // font-size: 0.15rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .delect {
                  width: 0.3rem;
                  height: 0.3rem;
                  border: none;
                  border-radius: 0.02rem;
                  padding: 0.08rem;
                  color: #fff;
                  background-color: #f56c6c;

                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }
            }

            .back {
              background: #dddddd;
            }
          }
        }
      }

      .submit {
        margin: 0.23rem;
        padding: 0.1rem 0.34rem;
        background: #409eff;
        box-shadow: 0px 0.04rem 0.04rem 0px rgba(11, 3, 6, 0.11);
        border-radius: 0.11rem;
        // font-size: 0.17rem;
        //font-weight: bold;
        color: #ffffff;
      }

      .submit1 {
        margin: 0.23rem;
        box-shadow: 0px 0.04rem 0.04rem 0px rgba(11, 3, 6, 0.11);
      }
    }

    //修改地区选择框样式开始

    .divwrap {
      z-index: 999;
      overflow-y: auto;
      background: #fff;
      //overflow: hidden;
    }

    //修改地区选择框样式结束
  }

  ::v-deep .el-dialog {
    display: flex;
    display: -ms-flex;
    /* 兼容IE */
    flex-direction: column;
    -ms-flex-direction: column;
    /* 兼容IE */
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ::v-deep .el-dialog__body {
    padding: 0 10px;
    max-height: 100%;
    flex: 1;
    -ms-flex: 1 1 auto;
    /* 兼容IE */
    overflow-y: auto;
    overflow-x: hidden;
  }

  .DialogVisibleImg ::v-deep .el-dialog__body {
    padding: 30px 40px;
    max-height: 100%;
    flex: 1;
    -ms-flex: 1 1 auto;
    /* 兼容IE */
    overflow-y: auto;
    overflow-x: hidden;
  }

  .VersionDifferent {
    margin: 0 auto;
    width: 100%;

    .border_none {
      border: none;
    }

    .version_tips {
      width: 100%;
      background: #ffffff;
      margin: 5px 0;
      //line-height:  4vh;
      //height: 4vh;
      font-size: 0.18rem;
      z-index: 999;
      top: 0.5rem;
    }

    .version_top_back {
      height: 22vh;
      background: #ffffff;
      z-index: 999;
      width: 100%;
      box-shadow: 0px 0.04rem 0.23rem 0px rgba(11, 3, 6, 0.22);

      .version_top {
        width: 100%;

        .top_item {
          flex: 2;
          height: 100%;
          font-size: 0.16rem;

          .top_item_top {
            flex: 1;
            width: 100%;

            .top_item_inner {
              flex: 1;
              height: 100%;
              border-left: 0.01rem solid rgba(0, 0, 0, 0.2);
              border-top: 0.01rem solid rgba(0, 0, 0, 0.2);
            }

            .top_item_inner_right {
              border-right: 0.01rem solid rgba(0, 0, 0, 0.2);
            }

            .top_item_inner_bottom {
              border-bottom: 0.01rem solid rgba(0, 0, 0, 0.2);
            }
          }

          .flex_1 {
            flex: 1;
          }

          .flex_2 {
            flex: 2;
          }

          .flex_3 {
            flex: 3;
          }
        }

        .item_blue {
          border-right: none;
          background: rgba(11, 155, 218, 0.22);
        }

        .item_yellow {
          border-right: none;
          background: rgba(255, 241, 0, 0.22);
        }

        .item_pink {
          border-right: none;
          background: rgba(236, 105, 65, 0.22);
        }

        .item_green {
          background: rgba(34, 172, 56, 0.22);
        }
      }

      .version_top1 {
        flex: 1;
      }

      .version_top2 {
        flex: 4;
      }

      .version_top3 {
        flex: 3;
      }
    }

    .version_body {
      padding-bottom: 0.6rem;
      height: 50vh;
      overflow-y: auto;

      .version_items {
        .body_title {
          margin: 0.33rem 0 0.2rem;

          .title_item {
            justify-content: flex-start;
            flex: 1;

            .body_tag {
              width: 0.23rem;
              height: 0.23rem;
              color: #b6b6b6;
              font-size: 0.18rem;
              border: 0.01rem solid #b6b6b6;
              border-radius: 50%;
            }

            .body_info {
              margin-left: 0.05rem;
              color: #0066ff;
              font-size: 0.18rem;
            }
          }
        }

        .version_item {
          display: flex;

          .item_left {
            flex: 2;
            border-left: 0.01rem solid #b6b6b6;
            border-top: 0.01rem solid #b6b6b6;
            border-bottom: 0.01rem solid #b6b6b6;
          }

          .item_right {
            flex: 12;

            .body_content {
              .body_items {
                .body_item {
                  height: 0.45rem;
                  flex: 1;
                  font-size: 0.13rem;
                  color: #696969;
                  border-left: 0.01rem solid #b6b6b6;
                  border-top: 0.01rem solid #b6b6b6;

                  img {
                    width: 0.28rem;
                  }
                }

                .body_item2 {
                  flex: 2;
                }

                .body_bottom {
                  border-bottom: 0.01rem solid #b6b6b6;
                }

                .body_right {
                  border-right: 0.01rem solid #b6b6b6;
                }
              }
            }
          }
        }
      }
    }
  }

  .DialogVisibleAgree {
    height: 70vh;
    overflow-y: auto;
    padding: 0 1rem 0.3rem;
    color: #000;

    .total_title {
      font-size: 0.4rem;
      font-weight: bold;
      margin: 0.2rem 0 0;
    }

    .total_title_intro {
      font-size: 0.36rem;
    }

    .catalogue {
      font-size: 0.22rem;
      font-weight: bold;
      margin-top: 0.2rem;

      .catalogue_item {
        margin-top: 0.2rem;
        text-align: left;
      }
    }

    .empower {
      margin-top: 1rem;

      .empower_item {
        margin-top: 0.15rem;
        font-size: 0.22rem;

        .empower_left {
          flex: 1;
          margin-right: 1rem;
        }

        .empower_right {
          flex: 1;
          margin-left: 1rem;
        }
      }
    }

    .sign {
      margin-top: 1rem;
      font-size: 0.22rem;
      text-indent: 2em;
    }

    .substance {
      .substance_item {
        font-size: 0.22rem;
        text-indent: 0.44rem;
        text-align: left;

        .substance_title {
          margin: 0.5rem 0;
          font-weight: bold;
        }

        .substance_conten {
          line-height: 0.4rem;
        }
      }
    }

    .agreen_page {
      margin: 0.5rem 0;
      font-size: 0.22rem;
      text-align: left;
    }
  }

  .SignDialog {

    //.show-img{
    //  width:400px;
    //  height:200px;
    //  border:1px solid #123456;
    //}
    //.show-info{
    //  width:400px;
    //  height:200px;
    //  font-size:24px;
    //  display:flex;
    //  align-items:center;
    //  justify-content:center;
    //}
    .qianming-container {
      width: 600px;
      height: 400px;
      margin: 20px auto;
      position: relative;
    }

    .contro-container {
      width: 600px;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      background-color: #d3d3d3;
      position: absolute;
      bottom: 0px;
    }

    .text {
      font-size: 14px;
    }

    .item {
      margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }

    .clearfix:after {
      clear: both;
    }

    .box-card {
      width: 95%;
      margin-left: 2.5%;
      margin-top: 20px;
    }
  }
}
</style>
